import classNames from "classnames";

type StaticTagProps = {
  text: string;
  /** Tint applied to both background and text. */
  color?: "cerise" | "blue" | "grey";
  className?: string;
  /** Keeps the tag on one line. Turn off to let long text wrap rather than overflow. */
  noWrap?: boolean;
};

// TODO: The component design for variants has not been documented for this yet, so will need to be added
/**
 * Non-interactive label with a tinted background.
 *
 * Use `Chip` instead when it needs to be clickable.
 */
export const StaticTag = ({
  text,
  color = "cerise",
  className = "",
  noWrap = true,
}: StaticTagProps) => {
  return (
    <div data-testid="static-tag" className={classNames(className, "")}>
      <div
        data-testid={"static-tag__inner"}
        className={classNames("h-max-content px-[6px] py-1", {
          "w-max-content whitespace-nowrap": noWrap,
          "max-w-fit text-pretty": !noWrap,
          "bg-[rgba(216,28,94,0.1)]": color === "cerise",
          "bg-[rgba(51,80,219,0.1)]": color === "blue",
          "bg-[rgba(2,2,49,0.1)]": color === "grey",
        })}
      >
        <p
          className={classNames("text-[14px]", {
            "text-cerise": color === "cerise",
            "text-pro-blue": color === "blue",
            "text-black-rock": color === "grey",
          })}
        >
          {text}
        </p>
      </div>
    </div>
  );
};
